import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useSyncCompetitionAdminMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, emails }: { id: number; emails: string[] }) => {
      const { data } = await SSF.api.competitionsListCompetitionAdminsRetrieve(id);

      for (const email of emails) {
        if (!data.competition_admins.includes(email)) {
          await SSF.api.competitionsAddCompetitionAdminCreate(id, { email });
        }
      }

      const toBeRemoved = data.competition_admins.filter(e => !emails.includes(e));

      for (const email of toBeRemoved) {
        await SSF.api.competitionsRemoveCompetitionAdminCreate(id, { email });
      }
    },
    onSuccess: (_, variables) => {
      client.invalidateQueries({ queryKey: keys.list(variables.id) });
    },
  });
}
